import { NavigateFunction } from "react-router-dom";
import { ROUTES, RouteValue } from "./routes";

// static routes — exact match (no :id params)
const STATIC_ROUTES = new Set(
    Object.values(ROUTES).filter(r => !r.includes(":"))
);

// dynamic routes — convert :id pattern to regex
const DYNAMIC_ROUTES = Object.values(ROUTES)
    .filter(r => r.includes(":"))
    .map(r => ({
        pattern: new RegExp(
            "^" + r.replace(/:[^/]+/g, "[^/]+") + "$"
        ),
    }));

function extractPath(deeplink: string): string | null {
    try {
        if (deeplink.startsWith("http://") || deeplink.startsWith("https://")) {
            const url = new URL(deeplink);
            return url.pathname + url.search;
        }

        if (!deeplink.startsWith("/")) {
            const [segment, ...rest] = deeplink.split("/");
            const rejoined = rest.join("/");
            if (rejoined.includes("=")) {
                return `/${segment}?${rejoined}`;
            }
            return `/${deeplink}`;
        }

        return deeplink;
    } catch {
        return null;
    }
}

function isKnownRoute(pathname: string): boolean {
    const path = pathname.split("?")[0];

    const isStatic = STATIC_ROUTES.has(path as RouteValue);
    const isDynamic = DYNAMIC_ROUTES.some(({ pattern }) => pattern.test(path));

    return isStatic || isDynamic;
}

export function navigateFromDeeplink(
    deeplink: string | undefined | null,
    navigate: NavigateFunction,
): void {
    if (!deeplink) return;

    const path = extractPath(deeplink.trim());

    if (!path) {
        console.warn("[Deeplink] Could not extract path from:", deeplink);
        return;
    }

    if (!isKnownRoute(path)) {
        console.warn("[Deeplink] No matching route for:", path);
        return;
    }

    navigate(path, { replace: true });
}